// /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/
export const emailRegex = new RegExp(`[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$`);

export function Validate(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function ValidateHost(email: string, host: string): boolean {
    const escapedHost = host.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // ���������� �����������
    const emailRegex = new RegExp(`^[^\\s@]+@${escapedHost}$`);
    return emailRegex.test(email);
}
